export const COURSES_API = {
  GET_COURSES_API: "/LandingCourses/paged",
  GET_PROMOTION_COURSES_API: "/LandingCourses/promotion",
  GET_COURSES_API_ERROR_STRING: "Get courses error",
  GET_PROMOTION_COURSES_API_ERROR_STRING: "Get promotion courses error",
  GET_COURSES_SEARCH_API: "/landingcourses/search",
  GET_COURSES_SEARCH_API_ERROR_STRING: "Get courses search error",
};

export const SERIES_API = {
  GET_SERIES_API: "/LandingCourses/series/paged",
  GET_SERIES_API_ERROR_STRING: "Get VOD Series error",
};

export const COURSE_TABS_API = {
  GET_COURSE_TABS_API: COURSES_API.GET_COURSES_API + "/tabs",
  GET_COURSE_TABS_API_ERROR_STRING: "Get course tabs error",
};

export const COURSE_DISCOUNT_API = {
  GET_COURSE_DISCOUNT_API: COURSES_API.GET_COURSES_API + "/discount",
  GET_COURSE_DISCOUNT_API_ERROR_STRING: "Get course discount error",
};

export const COURSE_LIVE_API = {
  GET_COURSE_LIVE_API: COURSES_API.GET_COURSES_API + "/live",
  GET_COURSE_LIVE_API_ERROR_STRING: "Get course live error",
};

export const COURSE_ITEM_API = {
  GET_COURSE_ITEM_API: COURSES_API.GET_COURSES_API,
  GET_COURSE_DETAIL_API_ERROR_STRING: "Get course detail error",
  GET_COURSE_ITEM_REVIEW_API: COURSES_API.GET_COURSES_API + "/review",
  GET_COURSE_ITEM_REVIEW_API_ERROR_STRING: "Get course item review error",
  POST_COURSE_ITEM_REGISTER_API: COURSES_API.GET_COURSES_API + "/register",
  POST_COURSE_ITEM_REGISTER_API_ERROR_STRING: "Post course item register error",
  POST_COURSE_ITEM_ADD_TO_CART_API: COURSES_API.GET_COURSES_API + "/add-to-cart",
  POST_COURSE_ITEM_ADD_TO_CART_API_ERROR_STRING: "Post course item add to cart error",
  POST_COURSE_ITEM_LIKE_API: COURSES_API.GET_COURSES_API + "/like",
  POST_COURSE_ITEM_LIKE_API_ERROR_STRING: "Post course item like error",
  POST_COURSE_BOOKMARK_API: COURSES_API.GET_COURSES_API + "/bookmark",
  POST_COURSE_BOOKMARK_API_ERROR_STRING: "Post course bookmark error",
};

export const QUIZ_API = {
  GET_QUIZ_FREE_TEST_API: "/quizzes/latest/free-test/id",
  GET_QUIZ_ITEM_API: "/quizzes",
  POST_TEST_ANSWER_API: "/quizzes/free-test",
  GET_FREE_QUIZ_API_ERROR: "Get free test error",
  POST_QUIZ_ANSWER_API_ERROR: "Post test answer error",
  GET_TOPIK_QUIZ_API: "/quizzes/list_quiz_topik",
  GET_QUIZ_RESULT_DETAIL_API: "/quizzes/result/detail",
  GET_HIGHEST_SCORE: "/quizzes/GetHighestScore",
  GET_RESULT_HISTORY: "/quizzes/result/history",
  GET_TOPIK_TEST_LIST: "/quizzes/listTopikTestGroup",
  GET_TOPIK_TEST_RESULT_DETAIL: "/quizzes/statistic",
};

export const QUESTION_API = {
  GET_BOOKMARK_QUESTION_API: "/bookmark_question",
  GET_QUESTION: "/questions",
};

export const BOOKMARK_QUESTION_API = {
  GET_BOOKMARK_QUESTION_API: "/bookmark_questions",
};

export const FAQ_API = {
  GET_FAQ_SECTION: "/FAQSectionsManagement",
  GET_FAQ_SECTION_IN_USED: "/FAQSectionsManagement/in-used",
  GET_FAQ_LIST: "/FAQsManagement/landing-paged",
  GET_FAQ_API_ERROR: "Cannot load FAQ item",
};

export const CONTACT_US_API = {
  POST_CONTACT_US_API: "/ContactUsManagement",
  POST_CONTACT_US_API_ERROR: "Cannot post contact us",
};

export const SHOPPING_CART_API = {
  GET_SHOPPING_CART_DETAIL: "/ShoppingCart/GetCartDetail",
  GET_SHOPPING_CART_DETAIL_ERROR: "Cannot get shopping cart detail",
  ADD_SHOPPING_CART_ITEM: "/ShoppingCart/AddItem",
  ADD_SHOPPING_CART_ITEM_ERROR: "Cannot add shopping cart item",
  UPDATE_SHOPPING_CART_ITEM: "/ShoppingCart/UpdateItem",
  UPDATE_SHOPPING_CART_ITEM_ERROR: "Cannot update shopping cart item",
};

export const USER_API = {
  POST_CHANGE_LANGUAGE: "/AppUser/SetLanguage",
  POST_CHANGE_CURRENCY: "/AppUser/SetCurrency",
  POST_CHANGE_LANGUAGE_ERROR: "Cannot change language",
  POST_CHANGE_CURRENCY_ERROR: "Cannot change currency",
  GET_VALIDATE_EMAIL_API: "/AppUser/validate/email",
  GET_VALIDATE_ID_API: "/AppUser/validate/username",
};

export const ENTERPRISE_API = {
  GET_USER_ENTERPRISES: "/Enterprises/user-enterprises",
  GET_USER_ENTERPRISES_ERROR: "Cannot get user enterprises",
};

export const COUPON_API = {
  GET_COUPON_API: "/CouponsManagement",
  GET_COUPON_API_ERROR: "Cannot get coupons",
};

export const HOME_PAGE_BASE_API = "/homepage";

export const HOME_PAGE_API = {
  GET_FEATURED_TEACHERS_API: HOME_PAGE_BASE_API + "/ranking/current",
  GET_SAMPLE_LESSONS_API: HOME_PAGE_BASE_API + "/vods/free",
  GET_VOD_PACKAGES_API: HOME_PAGE_BASE_API + "/vods/suggested",
  GET_SPECIAL_PACKAGES_API: HOME_PAGE_BASE_API + "/events/suggested",
  GET_SUGGESTED_VOD_PACKAGES_API: "/LandingPackages/suggested",
  GET_SUGGESTED_FEATURED_TEACHERS_API: HOME_PAGE_BASE_API + "/ranking/level",
};

export const VOD_API = {
  GET_VOD_INFORMATION_API: "/LandingCourses/vodInformation",
  GET_VOD_INFORMATION_API_ERROR_STRING: "Get VOD information error",
  GET_VOD_WAITING_LIST_API: "/LandingCourses/vodWaitingList",
  GET_VOD_WAITING_LIST_API_ERROR_STRING: "Get VOD waiting list error",
  GET_VOD_MEDIA_FOR_CURRENT_USER_API: "/LandingCourses/GetVodMediaForCurrentUser",
  GET_VOD_MEDIA_FOR_CURRENT_USER_API_ERROR_STRING: "Get VOD media for current user error",
  ADD_TO_FAVORITE_API: "/LandingCourses/vod/favorite",
  ADD_TO_FAVORITE_API_ERROR_STRING: "Add to favorite error",
  REMOVE_FROM_FAVORITE_API: "/LandingCourses/vod/favorite",
  REMOVE_FROM_FAVORITE_API_ERROR_STRING: "Remove from favorite error",
  GET_VOD_RATING_API: "/LandingCourses/ratings",
  GET_SERIES_SUMMARY_API: "/LandingCourses/series-summary",
  GET_SERIES_SUMMARY_API_ERROR_STRING: "Get series summary error",
};

export const PRODUCT_QUESTION_API = {
  BASE: "/ProductQuestions",
  BY_PRODUCT: "/ProductQuestions/by-product",
  TRAINER_NAME: "/ProductQuestions/trainer-name",
  ERROR_STRING: "Product Q&A error",
};

export const SHORTS_API = {
  BASE: "/shorts",
  ERROR_STRING: "Shorts error",
};

export const REVIEWS_API = {
  BASE: "/reviews",
  PUBLIC: "/reviews/public",
  ERROR_STRING: "Reviews error",
};

// FileAttachment content types as returned by the API (ContentType, upper-cased).
export const ATTACHMENT_TYPE = {
  IMAGE: "IMAGE",
  AUDIO: "AUDIO",
};

export const REPLAY_API = {
  GET_REPLAY_INFORMATION_API: "/LandingCourses/replayInformation",
  GET_REPLAY_INFORMATION_API_ERROR_STRING: "Get replay information error",
  GET_REPLAY_MEDIA_FOR_CURRENT_USER_API: "/LandingCourses/GetReplayMediaForCurrentUser",
  GET_REPLAY_MEDIA_FOR_CURRENT_USER_API_ERROR_STRING: "Get replay media for current user error",
  GET_REPLAY_WAITING_LIST_API: "/LandingCourses/replayWaitingList",
  GET_REPLAY_WAITING_LIST_API_ERROR_STRING: "Get replay waiting list error",
};

export const POPUP_API = {
  GET_POPUP_BY_PAGE: "/popups/page",
};

export const CLASS_API = {
  GET_LIST: "/LandingCourses/class/list",
  GET_INFORMATION: "/LandingCourses/class/information",
  GET_INFORMATION_ERROR: "Cannot get class information",
  GET_TRAINER: "/TrainersLanding",
  GET_TRAINER_ERROR: "Cannot get class trainer",
  GET_RATINGS: "/LandingCourses/ratings",
  GET_RATINGS_ERROR: "Cannot get class ratings",
  GET_RATINGS_PERCENT: "/LandingCourses/ratings",
  GET_RATINGS_CAN_RATING: "/LandingCourses/ratings",
  POST_RATINGS_CREATE: "/LandingCourses/ratings",
  GET_RELATED: "/LandingCourses/class/related",
  GET_RELATED_ERROR: "Cannot get related classes",
};
